module.exports = __webpack_public_path__ + "img/map.3b9e46c1.svg";